import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getEntityName',
})
export class GetEntityNamePipe implements PipeTransform {
  transform(obj: any): any {
    let res = '';
    if (obj && obj.name) {
      res += obj.name;
    }
    if (obj && obj.first_name) {
      res += obj.first_name + ' ';
    }
    if (obj && obj.last_name) {
      res += obj.last_name + ' ';
    }
    if (obj && obj.last_name2) {
      res += obj.last_name2;
    }
    if (obj && obj.entity_type === 'PATIENT' && obj.entity_id) {
      res += ' (' + obj.entity_id + ')';
    }
    return res;
  }
}
